import * as React from 'react';
import { LoadingIndicator, InclinationChart, PVAContainer, PVANav, PVAMultiSelect, PVABadge, PVADiamond, PVAContentHeader, PVACharacteristicGroupModal, PVAContentBody, PVACharacteristicModal, LoadingIndicatorMini } from '../../../components';
import { ReportType } from '../../../enums';
import { UserDataService, ReportDataService, CharacteristicDataService, CharacteristicGroupDataService } from '../../../services';
import { User, CharacteristicGroup, Characteristic, CharacteristicText, SurveyVersion, CharacteristicGroupCharacteristic, CharacteristicGroupSubGroupCharacteristic, UserCharacteristicToggle } from '../../../models';
import { BaseRouteProps } from '../../../interfaces';
import { UserStore, FilterStore } from '../../../stores';
import { inject, observer } from 'mobx-react';
import { computed } from 'mobx';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface ComparisonReportState {
    selectedUserData: any[];
    users: User[];
    reportType: ReportType;
    characteristicGroups: CharacteristicGroup[];
    characteristics: Characteristic[];
    orgId: number;
    teamId: number;
    surveyId: number;
    surveyVersionId: number;
    surveyVersions: SurveyVersion[];
    selectedUserIds: number[];
    sticky: boolean;
    stickySize: number;
    stickyGroups: number[];
    activeInd: number;    
    groupPos: number[];
    loading: boolean;
    miniLoader: boolean;
    pdfLoader: boolean;
    open: boolean;
    markedCharacteristics: UserCharacteristicToggle[];
}

interface ComparisonReportProps extends BaseRouteProps<{}> {
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

@inject('UserStore', 'FilterStore') @observer
export class ComparisonReport extends React.Component<ComparisonReportProps, ComparisonReportState> {
    private userDataService = new UserDataService(this.props.notificationService);
    private reportDataService = new ReportDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private banner: any;
    private pageTop: any;
    private groupEls: any[];
    // private scrollUpdate: any | undefined;

    @computed get userRole() {
        return this.props.UserStore!.userInfo.userRole;
    }

    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }

    @computed get team() {
        if (this.props.FilterStore && this.props.FilterStore.team) {
            return this.props.FilterStore.team;
        }
        return null;
    }

    @computed get userPermissions() {
        return this.props.UserStore!.userInfo.userPermissions;
    }

    @computed get surveyReportType() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType;
        }
        return null;
    }

    constructor(props: ComparisonReportProps) {
        super(props);

        this.groupEls = [];
        // this.scrollUpdate = undefined;

        this.state = {
            selectedUserData: [],
            users: [],
            characteristicGroups: [],
            characteristics: [],
            reportType: ReportType.Standard,
            orgId: 0,
            teamId: 0,
            surveyId: 0,
            surveyVersionId: 0,
            surveyVersions: [],
            selectedUserIds: [],
            sticky: false,
            stickySize: 0,
            stickyGroups: [],
            activeInd: -1,
            groupPos: [],
            loading: false,
            miniLoader: false,
            pdfLoader: false,
            open: false,
            markedCharacteristics: []
        };
    }

    private update() {
        if (this.userRole !== 'user') {
            if (this.organization && this.organization.id !== this.state.orgId) {
                var orgId = this.organization.id;
                this.setState({
                    orgId: orgId,
                    loading: true
                });

                this.userDataService.getByOrganizationLight(orgId).then((users: User[]) => {
                    users.sort((a: User, b: User) => {
                        if (a.lastName > b.lastName) {
                            return 1;
                        } else if (a.lastName < b.lastName) {
                            return -1;
                        }

                        if (a.firstName > b.firstName) {
                            return 1;
                        } else if (a.firstName < b.firstName) {
                            return -1;
                        }

                        return 0;
                    });
                    this.setState({
                        users: users,
                        orgId: orgId,
                        selectedUserData: [],
                        selectedUserIds: [],
                        loading: false
                    });
                });
            }
        }

        if (this.team && this.team.id !== this.state.teamId) {
            this.setState({
                teamId: this.team.id,
                selectedUserData: [],
                selectedUserIds: []
            });
        } else if (!this.team && this.state.teamId) {
            this.setState({
                teamId: 0,
                selectedUserData: [],
                selectedUserIds: []
            });
        }

        if (this.survey !== null && this.state.surveyId !== this.survey.id) {
            var survey = this.survey;

            this.setState({
                surveyId: survey.id
            });
        }

        if (this.surveyVersion != null && this.state.surveyVersionId !== this.surveyVersion.id) {

            this.setState({
                surveyVersionId: this.surveyVersion.id,
                loading: true
            });

            // this.surveyVersionDataService.getAllBySurvey(survey).then((surveyVersions: SurveyVersion[]) => {
            //     this.setState({
            //         surveyVersions: surveyVersions
            //     });
            if (this.surveyVersion) {
                this.characteristicGroupDataService.getAllBySurveyVersion(this.surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                    var stickyGroups: number[] = [];
                    var groupPos: number[] = [];
                    characteristicGroups = characteristicGroups.filter((cg: CharacteristicGroup) => {
                        if (cg.secondaryReportID) {
                            return false;
                        }
                        return true;
                    });

                    characteristicGroups.map((data: any, ind: number) => {
                        stickyGroups[ind] = 0;
                        groupPos[ind] = 0;
                    });

                    this.setState({
                        characteristicGroups: characteristicGroups,
                        stickyGroups: stickyGroups,
                        groupPos: groupPos
                    });

                    if (this.surveyVersion) {
                        this.characteristicDataService.getAllBySurveyVersion(this.surveyVersion).then((characteristics: Characteristic[]) => {
                            this.setState({
                                characteristics: characteristics,
                                loading: false
                            });
                        });
                    }
                });
            }
           // });
        }
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    toggleUserSelect(e: any) {
        var id = Number(e.target.value);
        var ids = this.state.selectedUserIds;
        var ind = ids.indexOf(id);
        if (ind > -1) {
            ids.splice(ind, 1);
            var dataInd = this.state.selectedUserData.findIndex((data: any) => {
                return data.userId === id;
            });
            if (dataInd > -1) {
                var d = this.state.selectedUserData;
                d.splice(dataInd, 1);
                this.setState({
                    selectedUserData: d
                });
            }
        } else {
            ids.push(id);            
            if (this.surveyVersion && this.survey) {
                this.setState({
                    miniLoader: true
                });
                this.reportDataService.getIndividualReportDataLatest(id, this.surveyVersion.id).then((reportData) => { // this.survey.id, , this.surveyVersion.id
                    if (ids.indexOf(id) > -1) { // make sure it's still selected
                        this.state.selectedUserData.push({
                            data: reportData,
                            userId: id
                        });
                        this.setState({
                            selectedUserData: this.state.selectedUserData
                        });
                    }
                    this.setState({
                        miniLoader: false
                    });
                });
            }
        }
        this.setState({
            selectedUserIds: ids
        });
    }

    updateNav() {
                var stick = this.state.stickySize;
        
                if (this.banner && this.state.stickySize === 0) {
                    this.setState({
                        stickySize: this.banner.offsetTop
                    });
                    stick = this.banner.offsetTop;
                }
        
                var sticky = stick;
        
                if (this.pageTop.scrollTop >= sticky) {
                    this.setState({
                        sticky: true
                    });
                } else {
                    this.setState({
                        sticky: false
                    });
                }
        
                var stickies = this.state.stickyGroups;
                var i: number = 0;
                var activeInd: number = -1;
                if (this.state.sticky) {
                    for (; i < this.groupEls.length; i++) {
                        if (this.groupEls[i]) {
                            this.state.groupPos[i] = this.groupEls[i].offsetTop;
                        }
                        stickies[i] = 0; // white
                        if (this.state.groupPos[i] !== 0) {
                            if (this.pageTop.scrollTop >= this.state.groupPos[i]) {
                                stickies[i] = 1; // active
                                activeInd = i;
                                for (var j: any = 0; j < i; j++) {
                                    stickies[j] = 2; // past
                                }
                            }
                        }
                    }
                } else {
                    for (; i < this.groupEls.length; i++) {
                        stickies[i] = 0;
                    }
                }
                this.setState({
                    stickyGroups: stickies,
                    activeInd: activeInd
                });
        //     },
        //     1
        // );
    }

    handleScroll(event: any, t: any) {
        if (event.target.getAttribute('class') !== 'site-content-inner') {
            return;
        }
        this.updateNav();
    }

    tooltip(c: Characteristic) {
        if (!c.characteristicTexts) {
            return '';
        }

        var result = '';
        c.characteristicTexts.map((ct: CharacteristicText) => {
            if (ct.textType === 'tooltip') {
                result = ct.value;
            }
        });

        return result;
    }

    filteredCharacteristics(groupData: any, characteristic: Characteristic) {
        return groupData.data.filter((x: any) => {
            return x.characteristicID === characteristic.id || x.previousCharacteristicID === characteristic.id;
        });
    }

    private exportPDF() {
        if (this.state.selectedUserData) {
            var userIds: number[] = [];
            this.state.selectedUserData.map((data: any) => {
                userIds.push(data.userId);
            });

            this.setState(
                {
                    pdfLoader: true,
                    open: false
                });
            this.reportDataService.getComparisonReportDataPDF(this.state.surveyVersionId, userIds, this.state.markedCharacteristics, 'ComparisonReport', this.surveyReportType ? this.surveyReportType.id : undefined)
                .then(
                    (reportData: any) => {
                    this.setState(
                        {
                            pdfLoader: false
                        });
                },  (err: any) => {
                    this.setState(
                        {
                            pdfLoader: false
                        });
                });
        }
    }

    private ActionsButton(sticky: boolean) {
        return (
            <div className="btn-group dropdown">
                <button type="button" className="btn btn-primary"  onClick={(e) => this.setState({open: !this.state.open })}>
                    <span>Actions </span>
                    <span className="caret" />
                </button>
                <ul className={`action-menu dropdown-menu ${(this.state.open && (((sticky && this.state.sticky)) || (!sticky && !this.state.sticky))) ? 'open' : ''}`}>
                    <li className="options-header">Export Options</li>
                    <li className="options-entry" onClick={(e) => this.exportPDF()}>
                        <div className="options-entry-title">
                            <span className="glyphicon glyphicon-save-file" /> <span> PDF Export</span>
                        </div>
                    </li>
                </ul>
        </div>);
    }

    private GetKeyOverride(key?: string, fallback?: any) {
        if (key && this.props.FilterStore) {
            return this.props.FilterStore.GetKeyOverride(key, fallback || '');
        }
        return fallback;
    }

    public render() {
        // let modals: any[] = [];

        var offset = 0;

        var contentHeaderSmall = (
            <div className="row">
                <div className="col-sm-6 col-md-8 col-xs-12">
                    <div className="title">
                        {this.GetKeyOverride('comparisonReport', <span>PVA Comparison Report<span className="trademark">TM</span></span>)}
                         <span className="light"> for </span>
                        <PVAMultiSelect options={this.users} selected={this.state.selectedUserIds} onChange={(e: any) => this.toggleUserSelect(e)} FilterStore={this.props.FilterStore} />
                        {this.team && <span><span className="light"> in </span>'{this.team.name}'</span>}
                        {this.state.miniLoader && <LoadingIndicatorMini />}
                    </div>
                </div>
                <div className="col-sm-6 col-md-4 text-right">
                    {this.ActionsButton(true)}
                </div>
            </div>
        );

        return (
            <div className="site-content-inner" ref={(e) => this.pageTop = e} onScroll={(e) => this.handleScroll(e, this)}>
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                {this.survey && <div id={`survey-${this.survey.id}`} />}
                {this.surveyVersion && <div id={`surveyVersion-${this.surveyVersion.id}`} />}
                {this.surveyReportType && <div id={`surveyReportType-${this.surveyReportType.id}`} />}

                <PVAContentHeader>
                    <div className="row">
                        <div className="col-sm-10 col-md-8 col-xs-12">
                            <div className="title">
                                {this.GetKeyOverride('comparisonReport', <span>PVA Comparison Report <span className="trademark">TM</span></span>)} <span className="light"> for </span>
                                {!this.state.sticky && <PVAMultiSelect options={this.users} selected={this.state.selectedUserIds} onChange={(e: any) => this.toggleUserSelect(e)} FilterStore={this.props.FilterStore} />}
                                {this.team && <span><span className="light"> in </span>'{this.team.name}'</span>}
                                {this.state.miniLoader && <LoadingIndicatorMini />}
                            </div>
                        </div>
                        <div className="col-sm-2 col-md-4 text-right">
                            {this.ActionsButton(false)}
                        </div>
                    </div>
                </PVAContentHeader>

                <div ref={(e) => this.banner = e}>
                    {this.state.selectedUserData && <PVANav requireCharacteristics={true} FilterStore={this.props.FilterStore} content={contentHeaderSmall} activeInd={this.state.activeInd} groups={this.state.characteristicGroups} stickyGroups={this.state.stickyGroups} sticky={this.state.sticky} onSelect={(e: any) => this.updateNav()}  />}
                </div>

                {this.state.loading && <PVAContentBody><LoadingIndicator /></PVAContentBody>}
                {this.state.pdfLoader && <PVAContentBody><LoadingIndicator showPdfDescription={true} showBackground={true} showInPanel={true}/></PVAContentBody>}
                {!this.state.loading && !this.state.pdfLoader && <PVAContentBody>
                    {this.state.sticky && <div className="sticky-buffer" />}
                    {this.state.characteristicGroups.filter((x: CharacteristicGroup) => {
                        if (x.characteristicGroupDisplayType !== 'normal') {
                            return false;
                        }
                        if (
                            (!x.characteristicGroupCharacteristics || x.characteristicGroupCharacteristics.length === 0) &&                            
                            (!x.characteristicGroupSubGroups || x.characteristicGroupSubGroups.length === 0)
                         ) {
                            return false;
                        }
                        if (!this.surveyReportType) {
                            return true;
                        }
                        return x.surveyReportTypeID === this.surveyReportType.id;
                    }).map((group: CharacteristicGroup, groupInd: number) => {
                        var off = offset;
                        // offset += this.state.characteristics.filter((x: Characteristic) => {
                        //     return x.characteristicGroupID === group.id;
                        // }).length;

                        const icon = <PVADiamond step={groupInd + 1} />;
                        const title = <div>
                                <div className="title-sub">{group.subtitle}</div>
                                <span> {group.name}
                                    &nbsp;&nbsp;
                                    <span onClick={this.toggleGroupModal.bind(this, groupInd)} className="glyphicon glyphicon-info-sign icon-button" />
                                </span>
                            </div>;
                            
                        const content = (
                            <div>
                                <div className="inclination-table comparison">
                                    <div className="row">
                                        <div className="col-xs-6 col-md-5 col-lg-4">
                                            <div className="cell" />
                                            {
                                                this.filteredSortedCharacteristics(group).map((characteristic: Characteristic, charIndex: number) => {
                                                    offset++;

                                                    var propCharContent = '';
                                                    var propCharValue = '';
                                                    var showCharModal = false;
                                                    if (characteristic.characteristicTexts && characteristic.characteristicTexts.length > 0) {
                                                        showCharModal = characteristic.characteristicTexts[0].showModal;
                                                        propCharValue = this.getText(characteristic.characteristicTexts, 'tooltip');
                                                        propCharContent = this.getText(characteristic.characteristicTexts, 'higH_TEXT');
                                                    }

                                                    const propsChar = {
                                                        show: showCharModal,
                                                        onHide: this.toggleModal.bind(this, characteristic),
                                                        title: group.name,
                                                        content: propCharContent,
                                                        value: undefined,
                                                        description: propCharValue,
                                                        core: group.subtitle,
                                                        step: groupInd + 1,
                                                        name: characteristic.displayName ? characteristic.displayName : characteristic.name,
                                                        allowToggle: this.userPermissions.indexOf('scoreBarColorChange') > -1
                                                    };

                                                    const tooltip = <Tooltip id={`char-tooltip-${charIndex}`}><span dangerouslySetInnerHTML={{ __html: this.tooltip(characteristic) }} /></Tooltip>;
                                                    return <div className="text-left" key={`grid-cell-${charIndex}`}>
                                                                <div className="cell">
                                                                    <OverlayTrigger animation={''} delay={0} placement="top" overlay={tooltip}>
                                                                        <div className="grid-cell-title" onClick={this.toggleModal.bind(this, characteristic)}>
                                                                            <span className="characteristic-index">{off + charIndex + 1} </span>
                                                                            <span className="characteristic-info glyphicon glyphicon-info-sign icon-button" />
                                                                            <span className="characteristic-title">
                                                                                    <b>{characteristic.displayName ? characteristic.displayName : characteristic.name}</b>
                                                                            </span>
                                                                        </div>
                                                                    </OverlayTrigger>
                                                                
                                                                <PVACharacteristicModal {...propsChar} />
                                                            </div>
                                                            
                                                            {
                                                                this.state.selectedUserData.map((userData: any, userInd: number) => {
                                                                    var s = ' ';
                                                                    if (userData.data.style) {
                                                                        s = userData.data.style.name;
                                                                    }

                                                                    return <div key={`grid-cell-user-${userInd}`} className="cell grid-cell-user">
                                                                        <span>{userData.data.name}</span>
                                                                        {
                                                                            <div className="tiny-badge">
                                                                                <PVABadge style={s} badge={s[0]} />
                                                                            </div>
                                                                        }
                                                                    </div>;
                                                                })
                                                            }
                                                        </div>;
                                                })
                                            }
                                        </div>
                                        <div className="col-xs-6 col-md-7 col-lg-8">
                                            <div className="bg" />
                                            <div className="cell">
                                                <div className="row">
                                                    <div className="col-xs-6 text-left">
                                                        <div className="cell">
                                                            <span className="chart-content" style={{ left: -5 }}>Less Pronounced</span>
                                                        </div>
                                                    </div>
                                                    <div className="col-xs-6 text-right">
                                                        <div className="cell">
                                                            <span className="chart-content" style={{ right: 0 }}>More Pronounced</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.filteredSortedCharacteristics(group).map((characteristic: Characteristic) => {
                                                return <div key={characteristic.id}>
                                                    <div className="cell" />
                                                    <div className="comparison-bg">
                                                        {
                                                            this.state.selectedUserData.map((userData: any, userDataIndex: number) => {
                                                                var allowToggle = this.userPermissions.indexOf('scoreBarColorChange') > -1;

                                                                if (userData.data.inclinationGroups.length === 0) {
                                                                    return (<div className="cell" key={`grid-chart-empty-${userDataIndex}`}>
                                                                        <InclinationChart value={0} allowToggle={allowToggle} onToggle={() => this.charToggle(characteristic.id, userData.userId)}initialClickedState={this.toggleState(characteristic.id, userData.userId)}  />
                                                                    </div>);
                                                                }

                                                                var groupData = userData.data.inclinationGroups.filter((x: any) => {
                                                                    return x.characteristicGroupID === group.id || x.prevCharacteristicGroupID === group.id;
                                                                });

                                                                if (!groupData || groupData.length === 0) {
                                                                    return <div className="cell" key={`grid-chart-${userDataIndex}`}>
                                                                        <InclinationChart value={0} allowToggle={allowToggle} onToggle={() => this.charToggle(characteristic.id, userData.userId)} initialClickedState={this.toggleState(characteristic.id, userData.userId)}  />
                                                                    </div>;
                                                                }

                                                                var scoreData = groupData[0].data.find((inclination: any) => {
                                                                    return inclination.characteristicID === characteristic.id;
                                                                });

                                                                if (!scoreData && groupData[0].subGroups && groupData[0].subGroups.length > 0) {
                                                                    var subGroup = groupData[0].subGroups.find((sg: any) => {
                                                                        return sg.data.find((inclination: any) => {
                                                                            return inclination.characteristicID === characteristic.id;
                                                                        });
                                                                    });
                                                                    scoreData = subGroup.data.find((inclination: any) => {
                                                                        return inclination.characteristicID === characteristic.id;
                                                                    });
                                                                }

                                                                if (!scoreData) {
                                                                    return <div className="cell" key={`grid-chart-${userDataIndex}`}>
                                                                        <InclinationChart value={0} allowToggle={allowToggle} onToggle={() => this.charToggle(characteristic.id, userData.userId)} initialClickedState={this.toggleState(characteristic.id, userData.userId)} />
                                                                    </div>;
                                                                }

                                                                return (<div className="cell" key={`grid-chart-${userDataIndex}`}>
                                                                        <InclinationChart value={scoreData.value} allowToggle={allowToggle} onToggle={() => this.charToggle(characteristic.id, userData.userId)} initialClickedState={this.toggleState(characteristic.id, userData.userId)} />
                                                                    </div>);
                                                            })
                                                        }
                                                    </div>
                                                </div>;
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );

                        var propName = '';
                        var propContent = '';
                        var showModal = false;
                        if (group.characteristicGroupTexts && group.characteristicGroupTexts.length > 0) {
                            showModal = group.characteristicGroupTexts[0].showModal;
                            propName = group.name;
                            propContent = group.characteristicGroupTexts[0].value;
                        }

                        const props = {
                            show: showModal,
                            onHide: this.toggleGroupModal.bind(this, groupInd),
                            title: propName,
                            content: propContent,
                            core: group.subtitle,
                            step: groupInd + 1
                        };

                        return (
                            <div key={`group-${groupInd}`} ref={(e) => this.groupEls[groupInd] = e}>
                                <PVAContainer icon={icon} title={title} content={content} id={group.name} offset={true} />
                                <PVACharacteristicGroupModal {...props} />
                            </div>);
                    })}
                </PVAContentBody>}
            </div>);
    }

    charToggle(characteristicId: number, userId: number) {
        var markedCharacteristics = this.state.markedCharacteristics;
        var ind = markedCharacteristics.findIndex(m => {
            return m.characteristicId === characteristicId && m.userId === userId;
        });

        if (ind > -1) {
            markedCharacteristics.splice(ind, 1);
        } else {
            markedCharacteristics.push({
                characteristicId: characteristicId,
                userId: userId
            });
        }
        this.setState({
            markedCharacteristics: markedCharacteristics
        });
    }

    toggleState(characteristicId: number, userId: number) {
        return this.state.markedCharacteristics.findIndex(m => {
            return m.characteristicId === characteristicId && m.userId === userId;
        }) > -1;
    }

    toggleGroupModal(ind: number) {
        if (this.state.characteristicGroups[ind] && this.state.characteristicGroups[ind].characteristicGroupTexts && this.state.characteristicGroups[ind].characteristicGroupTexts.length > 0) {
            this.state.characteristicGroups[ind].characteristicGroupTexts[0].showModal = !this.state.characteristicGroups[ind].characteristicGroupTexts[0].showModal;
            this.forceUpdate();
        }
    }

    toggleModal(c: Characteristic) {
        if (c && c.characteristicTexts && c.characteristicTexts.length > 0) {
            c.characteristicTexts[0].showModal = !c.characteristicTexts[0].showModal;
            this.forceUpdate();
        }
    }

    getText(characteristicTexts: CharacteristicText[], key: string) {
        var charText = characteristicTexts.find((ct: CharacteristicText) => {
            return ct.textType === key;
        });
        if (charText) {
            return charText.value;
        }
        return '';
    }

    filteredSortedCharacteristics(group: CharacteristicGroup) {
        return this.state.characteristics.filter((x: Characteristic) => {
            return this.filterCharacteristics(x, group);
        }).sort((c1: Characteristic, c2: Characteristic) => {
            return this.sortCharacteristics(c1, c2, group);
        });
    }

    filterCharacteristics(x: Characteristic, group: CharacteristicGroup) {        
        var g = x.characteristicGroupCharacteristics.find((cgc: CharacteristicGroupCharacteristic) => {
            return cgc.characteristicGroupID === group.id;
        });
        if (g) {
            return true;
        }

        // Look to see if the characteristic is in a sub group of this group
        if (x.characteristicGroupSubGroupCharacteristics) {
            var sg = x.characteristicGroupSubGroupCharacteristics.find((cgsgc: CharacteristicGroupSubGroupCharacteristic) => {
                return cgsgc.characteristicGroupSubGroup && cgsgc.characteristicGroupSubGroup.characteristicGroupID === group.id;
            });
            if (sg) {
                return true;
            }
        }

        return x.characteristicGroupID === group.id;
    }

    sortCharacteristics(c1: Characteristic, c2: Characteristic, group: CharacteristicGroup) {
        var sort1 = c1.sort;
        var sort2 = c2.sort;

        var cgc1 = c1.characteristicGroupCharacteristics.find((c: CharacteristicGroupCharacteristic) => {
            return c.characteristicGroupID === group.id;
        });
        var cgc2 = c2.characteristicGroupCharacteristics.find((c: CharacteristicGroupCharacteristic) => {
            return c.characteristicGroupID === group.id;
        });

        var sgcgc: CharacteristicGroupSubGroupCharacteristic | undefined;
        if (cgc1) {
            sort1 = cgc1.sort;
        } else {
            // look for subgroup
            sgcgc = c1.characteristicGroupSubGroupCharacteristics.find((cgc: CharacteristicGroupSubGroupCharacteristic) => {
                return cgc.characteristicGroupSubGroup && cgc.characteristicGroupSubGroup.characteristicGroupID === group.id;
            });
            if (sgcgc) {
                sort1 = sgcgc.characteristicGroupSubGroup.sort + sgcgc.sort;
            }
        }
        if (cgc2) {
            sort2 = cgc2.sort;
        } else {
            // look for subgroup
            sgcgc = c2.characteristicGroupSubGroupCharacteristics.find((cgc: CharacteristicGroupSubGroupCharacteristic) => {
                return cgc.characteristicGroupSubGroup && cgc.characteristicGroupSubGroup.characteristicGroupID === group.id;
            });
            if (sgcgc) {
                sort2 = sgcgc.characteristicGroupSubGroup.sort + sgcgc.sort;
            }
        }

        if (sort1 > sort2) {
            return 1;
        } else if (sort1 < sort2) {
            return -1;
        }
        return 0;
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/comparison/ComparisonReport.tsx